import type { IGetPatientReportsResponse, IPatientsReportRow } from './types';

export const mapPatientReportsResponse = (
  response: IGetPatientReportsResponse,
  t: (key: string) => string,
): IPatientsReportRow[] => [
  {
    key: 'active',
    label: t('labels.activePatientsReport'),
    rpm: response.activePatientsCount.rpmCount,
    ccm: response.activePatientsCount.ccmCount,
    total: response.activePatientsCount.totalCount,
  },
  {
    key: 'engaged',
    label: t('labels.engagedPatients'),
    rpm: response.engagedPatientsCount.rpmCount,
    ccm: response.engagedPatientsCount.ccmCount,
    total: response.engagedPatientsCount.totalCount,
  },
  {
    key: 'unengaged',
    label: t('labels.unengagedPatients'),
    rpm: response.unEngagedPatientsCount.rpmCount,
    ccm: response.unEngagedPatientsCount.ccmCount,
    total: response.unEngagedPatientsCount.totalCount,
  },
  {
    key: 'critical',
    label: t('labels.criticalReadingsOnlyPatients'),
    rpm: response.criticalReadingsOnlyCount.rpmCount,
    ccm: response.criticalReadingsOnlyCount.ccmCount,
    total: response.criticalReadingsOnlyCount.totalCount,
  },
  {
    key: '80mins',
    label: t('labels.patientsExceeding80Mins'),
    rpm: response.exceeding80MinsCount.rpmCount,
    ccm: response.exceeding80MinsCount.ccmCount,
    total: response.exceeding80MinsCount.totalCount,
  },
  {
    key: 'pending',
    label: t('labels.patientsPendingDischarge'),
    rpm: response.patientsPendingDischarge.rpmCount,
    ccm: response.patientsPendingDischarge.ccmCount,
    total: response.patientsPendingDischarge.totalCount,
  },
  {
    key: 'discharged',
    label: t('labels.dischargedPatients'),
    rpm: response.dischargedPatientsCount.rpmCount,
    ccm: response.dischargedPatientsCount.ccmCount,
    total: response.dischargedPatientsCount.totalCount,
  },
  {
    key: 'doNotCall',
    label: t('labels.patientsWithDoNotCallStatus'),
    rpm: response.doNotCallCount.rpmCount,
    ccm: response.doNotCallCount.ccmCount,
    total: response.doNotCallCount.totalCount,
  },
];

export const formatNumber = (value: number | string): string =>
  typeof value === 'number'
    ? value.toLocaleString('en-US').replace(/,/g, ' ')
    : value;
